import React, { useContext, useState } from 'react';
import { CloseCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Col, Form, Row } from 'antd';

import GenericAutoComplete from '@totem/components/common/autoCompletes/GenericAutoComplete';
import { EMPTY_ID } from '@totem/components/common/reference/ReferenceSelector';
import { SalesOrderLine } from '@totem/components/salesOrders/list/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { AutoCompleteValue } from '@totem/types/autoComplete';
import { ObjectReference } from '@totem/types/common';
import { SALES_ORDERS_ENDPOINT } from '@totem/utilities/endpoints';

const FormItem = Form.Item;

const styles = {
  addIcon: { marginLeft: '15px', color: '#1890ff' },
  removeIcon: { color: '#1890ff' },
  formItem: { paddingBottom: '0', marginBottom: '1rem' },
};

export interface Props {
  salesOrderLine: SalesOrderLine;
  onChanged: () => void;
}

const SalesOrderLineDevicesEditPanel = ({
  salesOrderLine,
  onChanged,
}: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [selectedDevice, setSelectedDevice] = useState<AutoCompleteValue>({
    value: EMPTY_ID,
    display: '',
  });

  const handleAdd = () => {
    if (selectedDevice.value === EMPTY_ID || selectedDevice.value === '') {
      return;
    }
    fetch(`${SALES_ORDERS_ENDPOINT}/${salesOrderLine.id}/devices`, {
      method: 'PUT',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        id: selectedDevice.value,
        name: selectedDevice.display,
      }),
    }).then(() => {
      setSelectedDevice({ value: EMPTY_ID, display: '' });

      onChanged();
    });
  };

  const handleRemove = (device: ObjectReference) => {
    fetch(
      `${SALES_ORDERS_ENDPOINT}/${salesOrderLine.id}/devices/${device.id}`,
      {
        method: 'DELETE',
        headers: new Headers({ Authorization: `Bearer ${getApiToken()}` }),
      },
    ).then(() => onChanged());
  };

  const buildingId = salesOrderLine.building?.id ?? EMPTY_ID;

  return (
    <Row>
      <Col span={12}>
        <b>Assigned Devices:</b>
        <br />
        {(salesOrderLine.devices ?? []).map((device) => (
          <span key={device.id}>
            <CloseCircleOutlined
              title="Remove Device"
              onClick={() => handleRemove(device)}
              style={styles.removeIcon}
            />
            &nbsp;{device.name}
            <br />
          </span>
        ))}
      </Col>
      <Col span={12}>
        <FormItem label="Add Device" colon={false} style={styles.formItem}>
          <Row>
            <Col span={20}>
              <GenericAutoComplete
                type="Device"
                label="Search devices"
                limit={25}
                filters={[{ field: 'buildingId', values: [buildingId] }]}
                selectedValue={selectedDevice}
                onSelect={setSelectedDevice}
                onChange={() => {}}
              />
            </Col>
            <Col span={4}>
              <PlusCircleOutlined
                title="Add Device"
                onClick={handleAdd}
                style={styles.addIcon}
              />
            </Col>
          </Row>
        </FormItem>
      </Col>
    </Row>
  );
};

export default SalesOrderLineDevicesEditPanel;
